import type {InventoryPlotRepository} from '@/domain/interfaces/InventoryPlotRepository';

export class GetInventoryPlotByUuidUseCase {
  constructor(private readonly repository: InventoryPlotRepository) {}
  async execute(uuid: string) {
    return this.repository.get(uuid);
  }
}
